import { render, staticRenderFns } from "./importStudent.vue?vue&type=template&id=1eba100e&"
import script from "./importStudent.vue?vue&type=script&lang=js&"
export * from "./importStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports